<div class="hero-image hero-image--overlay" [ngClass]="classes" [style.background-image]="TAP_getHeroImageStyles()">
	<!-- <div class="container"> -->
	<ng-content></ng-content>
	<!-- </div> -->
</div>
